module.exports = __webpack_public_path__ + "img/tcl_partner.5e4c3812.gif";